import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

export default function FloatingWhatsApp() {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chamar a Brasil Transportes no WhatsApp"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-5 right-5 z-50 block focus:outline-none focus:ring-2 focus:ring-[#FEFB0E] rounded-full"
    >
      <span className="absolute inset-0 rounded-full bg-[#50CF08] animate-ping-slow" aria-hidden="true" />
      <span className="relative flex items-center gap-2 bg-[#50CF08] hover:bg-[#42B006] text-white rounded-full p-4 md:px-6 shadow-2xl transition-colors">
        <MessageCircle className="w-7 h-7" />
        <span className="hidden md:block font-extrabold uppercase text-sm tracking-wide">
          Chamar guincho agora
        </span>
      </span>
    </a>
  );
}
